import { render, staticRenderFns } from "./PreviewImage.vue?vue&type=template&id=a56993ba&scoped=true&"
import script from "./PreviewImage.vue?vue&type=script&lang=js&"
export * from "./PreviewImage.vue?vue&type=script&lang=js&"
import style0 from "./PreviewImage.vue?vue&type=style&index=0&id=a56993ba&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a56993ba",
  null
  
)

export default component.exports